(() => {
  if (customElements.get('ob-app-offer')) return;
  const storageKey = 'oblivion-app-offer-5-v1';
  let shownThisPage = false;
  // Android WebView identifies itself with "; wv". Normal mobile Chrome does not.
  // Bridge checks also cover app shells which customize the default user agent.
  const isAppContext = () => /\bwv\b|com\.dd_oblivion|OblivionApp/i.test(navigator.userAgent)
    || Boolean(window.ReactNativeWebView || window.flutter_inappwebview)
    || navigator.standalone === true
    || matchMedia('(display-mode: standalone)').matches;
  // 2 Nov 2026: the app is Android-only, so the offer only opens on Android (desktop and iPhone shoppers
  // could not use it). The theme editor preview still shows it everywhere.
  const isAndroid = () => /Android/i.test(navigator.userAgent)
    || Boolean(navigator.userAgentData && /Android/i.test(navigator.userAgentData.platform || ''));
  // Shoppers who arrived from an ad keep shopping; layout/theme.liquid records the ad visit for the session.
  const isAdVisit = () => {
    if (window.Oblivion && window.Oblivion.appPopupHidePaid === false) return false;
    try { return sessionStorage.getItem('oblivion-paid-visit') === '1'; } catch { return false; }
  };
  customElements.define('ob-app-offer', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.preview = this.dataset.preview === 'true';
      this.standalone = matchMedia('(display-mode: standalone)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-app-dismiss]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.unlock(), options);
      this.querySelector('.ob-app-popup__download').addEventListener('click', () => this.dialog.close(), options);
      this.standalone.addEventListener('change', () => this.updateEligibility(), options);
      window.addEventListener('flutterInAppWebViewPlatformReady', () => this.updateEligibility(), options);
      this.updateEligibility();
    }
    updateEligibility() {
      clearTimeout(this.timer);
      if (isAppContext()) {
        if (this.dialog.open) this.dialog.close();
        this.unlock();
        return;
      }
      if (!this.preview && !isAndroid()) return;
      if (!this.preview && isAdVisit()) return;
      if (!this.hasSeen()) this.schedule();
    }
    /* 29 Oct (speed): on phones the offer waits for the first scroll or tap, or 8 s, so it does not cover the page while it loads. Desktop unchanged. */
    schedule() {
      const phone = window.innerWidth < 750 || matchMedia('(pointer: coarse)').matches;
      if (this.preview || !phone) {
        this.timer = setTimeout(() => this.openOffer(), this.preview ? 500 : 1800);
        return;
      }
      if (this.armed) return;
      this.armed = true;
      const evs = ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'];
      const off = () => { clearTimeout(this.armTimer); evs.forEach((n) => window.removeEventListener(n, go, true)); };
      const go = () => {
        off();
        this.armed = false;
        this.timer = setTimeout(() => this.openOffer(), 600);
      };
      evs.forEach((n) => window.addEventListener(n, go, { passive: true, capture: true }));
      this.armTimer = setTimeout(go, 8000);
    }
    hasSeen() {
      if (this.preview) return false;
      if (shownThisPage) return true;
      try { return sessionStorage.getItem(storageKey) === 'shown'; } catch { return false; }
    }
    openOffer() {
      if (!this.isConnected || isAppContext() || this.hasSeen()) return;
      // Do not interrupt another modal or show an offer in a background tab.
      const anotherModal = document.querySelector('dialog[open]') || Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([aria-hidden="true"])')).some(dialog => dialog.getClientRects().length > 0 && getComputedStyle(dialog).visibility !== 'hidden');
      if (document.visibilityState !== 'visible' || anotherModal) {
        this.timer = setTimeout(() => this.openOffer(), 1000);
        return;
      }
      this.dialog.showModal();
      document.documentElement.classList.add('ob-app-popup-open');
      if (!this.preview) {
        shownThisPage = true;
        try { sessionStorage.setItem(storageKey, 'shown'); } catch { /* The footer link remains available when storage is blocked. */ }
      }
    }
    unlock() { document.documentElement.classList.remove('ob-app-popup-open'); }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) { this.dialog.close(); this.unlock(); }
      this.events?.abort();
    }
  });
})();